export const HOME_PAGE = "/";
export const DASHBOARD_PAGE = "/dashboard";
export const ABOUT_PAGE = "/about";
export const TECH_PAGE = "/technology";
export const CONTACT_PAGE = "/contact";
